<template>
    <div
        class="ebk-page-breadcrumb bg-w p-3 mb-3"
        :class="{ 'ebk-page-breadcrumb--mobile': mobile }"
    >
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item
                v-for="(item, index) in items"
                :key="index"
                :to="breadcrumbItemTo(item, index)"
            >
                {{ item.label }}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
export default {
    name: "PageBreadcrumb",
    props: {
        /** { label: string, to?: string | object } ；仅末项可为纯文案，其余建议带 to */
        items: {
            type: Array,
            required: true,
        },
        mobile: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        /**
         * 与当前路由一致时不带 to，避免 el-breadcrumb 内部 push 触发 NavigationDuplicated。
         */
        breadcrumbItemTo(item, index) {
            if (index >= this.items.length - 1) {
                return undefined;
            }
            if (!item || item.to == null || item.to === "") {
                return undefined;
            }
            try {
                var resolved = this.$router.resolve(item.to);
                if (
                    resolved.route &&
                    resolved.route.path === this.$route.path
                ) {
                    return undefined;
                }
            } catch (e) {
                /* ignore */
            }
            return item.to;
        },
    },
};
</script>

<style scoped>
.ebk-page-breadcrumb--mobile {
    padding: 8px 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PageBreadcrumb.vue